import $ from "jquery";
import {GPProjectView} from "./gp-projectview.js";
import {GPLabel} from "./gp-label.js";
import {mode} from "./gp.js";
import {writable} from "svelte/store";

export let selectedLabel = writable(null);

export const fontSize = 12;

export let GPContextLabels = {
    labelLayer: null,
    storesInitiated: false,

    init: function (labelLayer) {
        GPContextLabels.labelLayer = labelLayer;

        if (!GPContextLabels.storesInitiated) {
            var func = function(ev, itemId) {
                GPContextLabels.removeItemImage(itemId);
            };
            $(document).off('GPItemRemoved', func).on('GPItemRemoved', func);

            var func2 = function(ev, item) {
                GPContextLabels.addLabelToView(item);
            };
            $(document).off('GPLabelHardEdited', func2).on('GPLabelHardEdited', func2);

            mode.subscribe((m) => {
                if ((m === "Plants" || m === "Structures" || m === "Snippets" || m === "Custom") && !GPContextLabels.labelLayer.listening())
                    GPContextLabels.activate();
                if ((m !== "Plants" && m !== "Structures" && m !== "Snippets" && m !== "Custom") && GPContextLabels.labelLayer.listening())
                    GPContextLabels.deactivate()
            })
            GPContextLabels.storesInitiated = true;
        }
    },

    activate: function(id) {
        GPContextLabels.labelLayer.listening(true);
    },

    deactivate: function() {
        GPContextLabels.labelLayer.listening(false);
    },

    addLabelToView: function(labelInstance) {
        labelInstance.createDisplayObject().then(function (konvaObject) {
            GPContextLabels.addKonvaLabelObject(labelInstance, konvaObject);
        });
    },

    addKonvaLabelObject: function(labelInstance, konvaObject) {
        GPContextLabels.removeItemImage(labelInstance.id);

        konvaObject.on("dragstart", function (event) {
            event.cancelBubble = true;
        });

        konvaObject.on("dragend", function (event) {
            event.cancelBubble = true;
            var itemInstance = GP.project.itemsById[event.target.attrs.id];
            var x = event.target.attrs.x + event.target.width() / 2;
            var y = event.target.attrs.y + event.target.height();
            var p = GPProjectView.coordsViewToProject(x, y);
            GP.saveUndo("modifyItems", [itemInstance]);
            GP.project.moveItem(itemInstance.id, p.x, p.y);
        });

        konvaObject.on("click tap", function (event) {
            event.cancelBubble = true;
            let id = event.target.attrs.id.replace('text_', '');
            var itemInstance = GP.project.itemsById[id];
            selectedLabel.set(itemInstance);
        });

        GPContextLabels.labelLayer.add(konvaObject);
        labelInstance.repositionItem();
    },

    removeItemImage: function (itemId) {
        var image = GPProjectView.stage.find('#' + itemId)[0];
        if (image) image.destroy();
    },

    repositionItems: function () {
        for (var p in GP.project.items) {
            var inst = GP.project.items[p];
            if (inst instanceof GPLabel )
            inst.repositionItem();
        }
    },

    resizeLabels (scale) {
        GPContextLabels.labelLayer.getChildren().forEach(function (el) {
            if (el.getClassName() === "Label") {
                el.scale({x: scale, y: scale});
            }
        });
    },

    onresize: function () {
        GPContextLabels.repositionItems();
    },


};

